import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonLoading: React.FC = () => {
  return <Skeleton width={162} height={24} />;
};

export default SkeletonLoading;
